export const SET_WORKERS = 'Workers/set';
export const SET_WORKERS_UPDATED = 'Workers/UpdateStatus/set';
